
import { useLanguage } from '../../../contexts/LanguageContext';

export default function Hero() {
  const { t } = useLanguage();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 px-6 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://readdy.ai/api/search-image?query=abstract%20flowing%20data%20visualization%20with%20environmental%20elements%2C%20network%20of%20biodiversity%20information%20nodes%2C%20soft%20green%20and%20earth%20tones%2C%20digital%20ecosystem%20mapping%2C%20clean%20minimalist%20background%20with%20organic%20patterns%2C%20professional%20technology%20aesthetic%2C%20subtle%20gradients%2C%20modern%20data%20science%20illustration&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Environmental Data Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-block px-4 py-2 bg-[#4a7c59]/30 backdrop-blur-sm rounded-full mb-6">
              <span className="text-[#f5f1e8] text-sm font-medium whitespace-nowrap">{t('hero.badge')}</span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight">
              {t('hero.title')}
            </h1>
            
            <p className="text-lg text-[#f5f1e8]/80 mb-10 leading-relaxed max-w-2xl">
              {t('hero.description')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button 
                onClick={() => scrollToSection('services')}
                className="px-8 py-4 bg-[#1a4d2e] text-white rounded-lg font-medium hover:bg-[#0f3820] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                {t('hero.cta.solutions')}
                <i className="ri-arrow-right-line"></i>
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className="px-8 py-4 bg-transparent border-2 border-[#f5f1e8] text-[#f5f1e8] rounded-lg font-medium hover:bg-[#f5f1e8]/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta.cases')}
              </button>
            </div>
          </div>

          <div className="hidden lg:flex justify-center items-center">
            <div className="relative w-full max-w-lg h-96">
              <div className="absolute top-0 left-1/4 w-48 h-64 bg-white rounded-2xl shadow-2xl transform rotate-6 hover:rotate-3 transition-transform duration-500 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20data%20dashboard%20interface%20showing%20biodiversity%20metrics%2C%20clean%20UI%20design%20with%20charts%20and%20graphs%2C%20environmental%20data%20visualization%2C%20green%20color%20scheme%2C%20professional%20application%20screenshot%2C%20species%20tracking%20interface&width=400&height=550&seq=card-001&orientation=portrait"
                  alt="Data Dashboard"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute top-12 right-1/4 w-48 h-64 bg-white rounded-2xl shadow-2xl transform -rotate-6 hover:-rotate-3 transition-transform duration-500 overflow-hidden z-10">
                <img 
                  src="https://readdy.ai/api/search-image?query=interactive%20map%20application%20showing%20ecosystem%20data%20points%2C%20geographic%20information%20system%20interface%2C%20environmental%20monitoring%20visualization%2C%20clean%20modern%20design%2C%20biodiversity%20hotspots%20mapping%2C%20professional%20GIS%20software&width=400&height=550&seq=card-002&orientation=portrait"
                  alt="Map Interface"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute top-24 left-1/2 transform -translate-x-1/2 w-48 h-64 bg-white rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-500 z-20 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=species%20analysis%20application%20interface%20with%20detailed%20charts%2C%20wildlife%20population%20tracking%20dashboard%2C%20conservation%20data%20visualization%2C%20modern%20clean%20UI%2C%20environmental%20research%20tool%2C%20professional%20analytics%20software&width=400&height=550&seq=card-003&orientation=portrait"
                  alt="Analytics Interface"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
